import * as XLSX from "xlsx";

/**
 * Date of Birth se current age calculate karne ke liye helper function
 */
const calculateAge = (dobString) => {
  if (!dobString) return "N/A";
  const birthDate = new Date(dobString);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age >= 0 ? `${age} Yrs` : "N/A";
};

/**
 * Excel Export Utility Function
 * @param {Array} customerList - Array of student objects
 * @param {string} companyName - Name of the company to display on top
 */
export const exportToExcel = (customerList = [], companyName = "COMPANY NAME") => {
  // 1. Sheet Header Rows (Company Title & Subtitle)
  const excelData = [
    [companyName.toUpperCase()], // Row 1: Company Name
    ["Candidate / Student List"], // Row 2: Subtitle
    [],                          // Row 3: Blank Row
    [                            // Row 4: Table Headers
      "S.No",
      "Registration No",
      "Full Name",
      "Father's Name",
      "Date of Birth",
      "Age",
      "Gender",
      "Mobile No",
      "Email",
      "Address",
    ],
  ];

  // 2. Data Rows Append Karein
  customerList.forEach((student, index) => {
    excelData.push([
      index + 1,
      student.registration_no || "N/A",
      student.full_name || `${student.first_name || ""} ${student.last_name || ""}`.trim() || "N/A",
      student.father_name || "N/A",
      student.date_of_birth || "N/A",
      calculateAge(student.date_of_birth),
      student.gender || "N/A",
      student.mobile_no || "N/A",
      student.email || "N/A",
      student.address || "N/A",
    ]);
  });

  // 3. Create Worksheet from 2D Array
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);

  // 4. Auto Column Widths Calculate Karein (Better Layout ke liye)
  const colWidths = [
    { wch: 6 },  // S.No
    { wch: 22 }, // Reg No
    { wch: 25 }, // Full Name
    { wch: 25 }, // Father Name
    { wch: 15 }, // DOB
    { wch: 10 }, // Age
    { wch: 12 }, // Gender
    { wch: 16 }, // Mobile
    { wch: 28 }, // Email
    { wch: 35 }, // Address
  ];
  worksheet["!cols"] = colWidths;

  // 5. Create Workbook and Append Worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

  // 6. Save & Download Excel File
  const fileName = `${companyName.replace(/\s+/g, "_")}_Candidates_${new Date().toISOString().slice(0, 10)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};